import { useIntl } from "react-intl";

const EncryptionInTransitAndAtRest = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.encryption-in-transit.title",
            defaultMessage: "Encryption in transit and at rest"
        }),
        body1: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.encryption-in-transit.body1",
            defaultMessage:
                "All customer data stored within Atlassian cloud products and services is encrypted in transit over public networks using Transport Layer Security (TLS) 1.2+ with Perfect Forward Secrecy (PFS) to protect it from unauthorized disclosure or modification."
        }),
        body2: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.encryption-in-transit.body2",
            defaultMessage:
                "Data drives on servers holding customer data and attachments in Jira Software Cloud, Jira Service Management Cloud, Jira Work Management Cloud, Confluence Cloud, Statuspage, Opsgenie, and Trello use full disk, industry-standard AES-256 encryption at rest."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body1}</p>
            <p>{messages.body2}</p>
        </div>
    );
};

export default EncryptionInTransitAndAtRest;
